
// import React, { useEffect } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { fetchAllUsers, clearUsers, updateUser,deleteUser } from '../../redux/slices/UsersSlice';
// import './AdminCSS/Details.css'; // Import the CSS file

// const UsersDetails = () => {
//   const dispatch = useDispatch();
//   const { users, loading, error } = useSelector((state) => state.users);

//   useEffect(() => {
//     dispatch(fetchAllUsers());
//     return () => {
//       dispatch(clearUsers());
//     };
//   }, [dispatch]);



//   return (
//     <div className="users-page">
//       {/* <h2 className="users-title">All Users</h2> */}
//       {loading && <p className="loading-text">Loading...</p>}
//       {error && <p className="error-text">Error: Unable to fetch users. Please try again later.</p>}

//       {!loading && !error && users.length > 0 && (
//         <table className="users-table">
//           <thead>
//             <tr>
//               <th>ID</th>
//               <th>Name</th>
//               <th>Email</th>
//               <th>Operations</th>
//             </tr>
//           </thead>
//           <tbody>
//             {users.map((user) => (
//               <tr key={user.user_id}>
//                 <td>{user.user_id}</td>
//                 <td>{user.user_name}</td>
//                 <td>{user.email}</td>
//                 <td className="operations">
//                   <button className="view-btn" onClick={() => alert(`View ${user.user_name}`)}>View</button>
//                   <button className="update-btn" onClick={() => alert(`Update ${user.user_name}`)}>Update</button>
//                   <button className="delete-btn" onClick={() => alert(`Delete ${user.user_name}`)}>Delete</button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       )}

//       {!loading && !error && users.length === 0 && <p className="empty-text">No users found.</p>}
//     </div>
//   );
// };

// export default UsersDetails;

import React, {useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllUsers, clearUsers, updateUser, deleteUser } from '../../redux/slices/UsersSlice';
import UserUpdate from './userupdate'; // Import Popup component
import './AdminCSS/Details.css'; // Import the CSS file

const UsersDetails = () => {
  const dispatch = useDispatch();
  const { users, loading, error } = useSelector((state) => state.users);
  const [selectedUser, setSelectedUser] = useState(null);
  const [formData, setFormData] = useState({ user_name: '', email: '' });


  useEffect(() => {
    dispatch(fetchAllUsers());
    return () => {
      dispatch(clearUsers());
    };
  }, [dispatch]);
  
  const handleUpdateClick = (user) => {
    setSelectedUser(user);
    setFormData({ user_name: user.user_name, email: user.email });
  };
  
  const handleUpdateSubmit = () => {
    if (selectedUser) {
      dispatch(updateUser({ userId: selectedUser.user_id, userData: formData }));
      setSelectedUser(null);
    }
  };

  const handleDelete = (userId) => {
    if (window.confirm('Are you sure you want to delete this user?')) {
      dispatch(deleteUser(userId));
    }
  };

  return (
    <div className="users-page">
      {loading && <p className="loading-text">Loading...</p>}
      {error && <p className="error-text">Error: Unable to fetch users. Please try again later.</p>}

      {!loading && !error && users.length > 0 && (
        <table className="users-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Email</th>
              <th>Operations</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => (
              <tr key={user.user_id}>
                <td>{user.user_id}</td>
                <td>{user.user_name}</td>
                <td>{user.email}</td>
                <td className="operations">
                  {/* <button className="view-btn" onClick={() => alert(`View ${user.user_name}`)}>View</button> */}
                  <button className="update-btn" onClick={() => handleUpdateClick(user)}>Update</button>
                  <button className="delete-btn" onClick={() => handleDelete(user.user_id)}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {!loading && !error && users.length === 0 && <p className="empty-text">No users found.</p>}

      {selectedUser && (
        <UserUpdate 
          formData={formData}
          setFormData={setFormData}
          handleUpdateSubmit={handleUpdateSubmit}
          setSelectedUser={setSelectedUser}
        />
      )}    
    </div>
  );
};

export default UsersDetails;
